import { createTheme, darken, lighten } from '@mui/material/styles';

const light = '#FFF';
const dark = '#000';

export const colours = {
    light: light,
    light100: darken(light, 0.05),
    light200: darken(light, 0.1),
    dark: dark,
    dark100: lighten(dark, 0.15),
    dark200: lighten(dark, 0.2),
    dark300: lighten(dark, 0.3),
    dark600: lighten(dark, 0.6),

    purple: '#8884d8',
    green: '#82ca9d',
    orange: '#ff7300',
    pink: '#ff6384', 
    blue: '#4bc0c0',
};

export const theme = createTheme({
  palette: {
    primary: {
      main: colours.dark300,
      contrastText: colours.light,
    },
    secondary: {
      main: colours.dark600,
      contrastText: colours.light,
    },
    success: {
      main: colours.dark,
      contrastText: colours.light,
    },
  },
  components: {
    MuiButton: {
      variants: [
        {
          props: { variant: 'outlined', color: 'secondary' },
          style: {
            backgroundColor: colours.light,
            borderColor: colours.dark300,
            color: colours.dark300,
            '&:hover': {
                backgroundColor: colours.light100,
                borderColor: colours.dark300,
            },
          },
        },
        {
            props: { variant: 'outlined', color: 'primary' },
            style: {
              backgroundColor: colours.light,
              borderColor: colours.dark,
              color: colours.dark,
              '&:hover': {
                  backgroundColor: colours.light200,
                  borderColor: colours.dark,
              },
            },
          },
        {
            props: { variant: 'contained', color: 'success' },
            style: {
              '&:hover': {
                backgroundColor: colours.dark200,
              },
            },
          },
      ],
    },
  },
  custom: {
    appBar: {
        main: colours.dark100,
        contrastText: colours.light,
    }
  }
});

// export default theme;
